export default __webpack_public_path__ + "assets/4a9ab29a10089191088de2b7c02c78e7.woff2";